import React, { Component } from 'react';
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

class UserInfo extends Component {
    constructor(props) {
        super(props);

        console.log('userName = ' + props.userName);
        this.state = {
            editingName : false,
            nameValue: this.props.userName || '',
        };
    }

    async doesUserOwnPage() {
        let own = this.props.userId === await this.props.ethereum.getUser() ||
            this.props.userId === undefined;
        console.log('does user own page = ' + own);
        return own;
    }

    onClickName() {
        console.log('onClickName');
        if (this.props.isEditing) {
            this.setState({editingName: true});
        }
    }

    onKeyPress(e) {
        if (e.key === 'Enter') {
            // update the damn thing
            this.chooseUserName();
        }
    }

    chooseUserName() {
        this.props.ethereum.users.setUserName(this.state.nameValue);
        this.setState({
            editingName: false,
        });

        if (this.state.nameValue !== '') {
            this.props.onUserNameUpdated(this.state.nameValue);
        }
    }

    isEditing() {
        return this.props.userName === undefined ||
            this.state.editingName;
    }

    render() {
        let userName = '';
        if (this.isEditing() && this.doesUserOwnPage()) {
            userName = (
                <InputGroup className="tag-sound-input">
                  <Input
                    onChange={(event) => {
                        this.state.nameValue = event.target.value;
                        this.setState(this.state);
                    }}
                    value={this.state.nameValue}
                    onKeyUp={(e) => this.onKeyPress(e)}
                    placeholder="Choose a user name" className="tag-sound-input-box"/>
                  <InputGroupAddon addonType="append">
                    <Button size="sm" onClick={() => this.chooseUserName()} color="secondary">Done</Button>
                  </InputGroupAddon>
                </InputGroup>
            );
        } else  {
            userName = (
                <span
                  onClick={() => this.onClickName()}
                  className="user-name">
                  {this.props.userName}
                </span>);
            }

        return (
            <div className="user-info">
              <div className="user-profile-picture-container">
                {this.props.profilePicture === undefined ? <div className="user-no-profile-picture"></div> : ''}
              </div>
              <div className="user-main-info-container">
                <div className="user-info-part-container">
                  {userName}
                </div>
                <div className="user-info-part-container">
                  <span className="user-location">
                    World Galaxy
                  </span>
                </div>
              </div>
            </div>
        );
    }
}

export default UserInfo;
